/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { CardText, ICardTextProps } from "../../Card";

export interface IFieldCardTextProps extends ICardTextProps {
	className?: string;
}

export const FieldCardText: React.FC<IFieldCardTextProps> = ({ className, children, ...props }) => {
	const baseClass = BEM("edt-field-card-text");

	if (className) {
		baseClass.add(className);
	}

	return (
		<CardText className={baseClass.toClassName()} {...props}>
			{children}
		</CardText>
	);
};
